import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const ProductIdContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IDButton = styled(BaseButton)`
  color: #1bace4;
  text-decoration: none;
  background-color: transparent;
  border: unset;
  margin: 0;
  padding: 0;
  text-align: left;
`;
